<template>
  <div id="app">
    <HeadNav />
    <router-view/>
    <FootNav />
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import FootNav from '@/components/FootNav.vue'

export default {
  name: 'Home',
  components: {
    HeadNav,
    FootNav
  },
  created() {  
    document.body.removeChild(document.getElementById('Loading'));

    var turl="";
    //如果是手机端打开
    if(!this.IsPC()){
      turl="http://www.branew.com.cn/mobile/#/";
      var _str=location.href.split('?')[1];
      if(typeof(_str)!="undefined"){
        turl=turl+"?"+_str;
      }
      window.location.href = turl;
    }
  },
  methods:{
    IsPC() {//判断页面是手机端还是pc端
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      },
  },
}
</script>

<style lang="scss">
*{
  padding: 0;
  margin: 0;
  box-sizing:border-box;
}
@media screen and (max-width:1200px) {
    body,html {
      font-size:15px ;
    }
}
@media screen and (max-width:992px) {
    body,html {
      font-size:14px ;
    }
}
@media screen and (max-width:768px) {
    body,html {
      font-size:13px ;
    }
}
@media screen and (max-width:576px) {
    body,html {
      font-size:12px ;
    }
}
@media screen and (max-width:400px) {
    body,html {
      font-size:11px ;
    }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
  background: #F3F5FA;
}
</style>
